<mat-form-field class="w-100" style="color: white;" data-cy="multiselect-form-field">
  <mat-label data-cy="multiselect-label">{{placeholder}}</mat-label>
  <mat-select [formControl]="formControl" [multiple]="multiple" [compareWith]="compareCategoryObjects"
              (openedChange)="onChanged($event)" data-cy="multiselect-select">
    <mat-select-trigger *ngIf="multiple" data-cy="multiselect-trigger-multiple">
      {{formControl.value ? getDisplayValue(formControl.value[0]) : ''}}
      <span *ngIf="formControl.value?.length > 1" data-cy="multiselect-additional-count">
        (+{{formControl.value.length - 1}} {{formControl.value?.length === 2 ? 'other' : 'others'}})
      </span>
    </mat-select-trigger>
    <mat-select-trigger *ngIf="!multiple" data-cy="multiselect-trigger-single">
      {{formControl.value ? getDisplayValue(formControl.value) : ''}}
    </mat-select-trigger>

    <div *ngIf="editable" data-cy="multiselect-editable-options">
      <mat-option *ngIf="multiple && isShowAllOption" #allSelected (click)="toggleAllSelection()" [value]="allSelectedValue" data-cy="multiselect-all-option">All</mat-option>
      <mat-option *ngFor="let item of items" [value]="valueExp.trim() === '' ? item : item[valueExp]" data-cy="multiselect-option">
        {{ displayExp.trim() === '' ? item : item[displayExp] }}
      </mat-option>
    </div>
    <div *ngIf="!editable" data-cy="multiselect-uneditable-options">
      <mat-option *ngFor="let item of uneditableItems" [value]="valueExp.trim() === '' ? item : item[valueExp]" [disabled]="true" data-cy="multiselect-uneditable-option">
        {{ displayExp.trim() === '' ? item : item[displayExp] }}
      </mat-option>
    </div>
  </mat-select>
</mat-form-field>
